// 引入react
import React, {PureComponent} from 'react';
import {Button} from 'antd';
// 引入核心grid组件
import ScGridTable from '../../../../components/display/table/gridTableCore';
// 定义业务的接口对象
import {getPermissionList, getUserMenuList} from '../../../../fetch/fetchApi';
import PropTypes from 'prop-types';
import {initModals} from "../../../../state/action/comAction";
import fetchHandler from '../../../../fetch/fetchHandler';
import RefreshGrid from '../../../../utils/refreshGrid';

class TransferTable extends PureComponent{
  constructor (props) {
    super(props);
    // 获取父组件传递的参数
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  componentWillMount () {
    // 如果存在静态表格数据，则定义如下
    this.staticDataArr = [
      {
        key: '0',
        title: '静态数据1'
      },
      {
        id: '1',
        title: '静态数据2'
      }
    ];

    // 初始定义表格数据
    this.generateSchema();
  }

  // 定义批量操作按钮
  generateTableButtons () {
    return <div className={'table-btn-group'}>
      <Button type={'primary'} onClick={() => this.try()}>批量操作试试</Button>
      <Button type={'primary'} onClick={() => this.addNewRow()}>新增一条静态数据</Button>
    </div>
  }

  addNewRow () {
    this.staticDataArr.push({
      key: this.staticDataArr.length + '',
      title: `静态数据${this.staticDataArr.length + 1}`
    });
    this.state.tableConfig.dataApi = this.staticDataArr;
    this.setState({
      tableConfig: this.state.tableConfig
    });
    this.state.tableConfig = JSON.parse(JSON.stringify(this.state.tableConfig));
  }

  try () {
    console.log(this.selectedRows);
  }

  // 表格列的定义
  generateSchema () {
    this.setState({
      tableConfig : {
        tableKey: this.props.tableKey,
        tableColumns : [
          {
            name: '角色名称',
            key: 'title',
            align: 'center'
          },
          {
            name: '操作',
            key: 'action',
            colType: 'action', // 操作列，可定义多种操作。
            actionMap: [
              {
                type: 'href',
                actionName: '编辑',
                handler: (res) => {
                  this.openTransfer(res);
                }
              },
              {
                type: 'confirm',
                actionName: '删除', // 默认actionName
                // 根据grid数据 自定义显示actionName
                render: (text) => {
                  return text ? '启用' : '禁用';
                },
                handler: (res) => {
                  this.openTab({'stubGroupIds': res.key}, {'key': 'demo2', titleText: '电站查询'});
                }
              }
            ]
          }
        ],
        tableParam: {
          pageCount: 10
        },
        tableInfo: {
          hasRow: !0, // 是否显示checkbox
          footer: this.generateTableButtons(),
          rowSelection: {
            onChange: (selectedRowKeys, selectedRows) => {
              this.selectedRows = selectedRows;
            },
            getCheckboxProps: record => ({
              disabled: record.companyName === '宝马', // Column configuration not to be checked
              name: record.name,
            })
          }
        },
        tableChange: () => {
          // grid翻页页，排序， 筛选过滤时触发
          console.log('change');
        },
        dataApi:  this.staticDataArr, // 可配置接口请求函数{getRoleList} 或者 静态数据数组
        autoRefresh: !1 // 设置为true 直接加载grid数据
      }
    });
  }

  initParams () {
    fetchHandler(getPermissionList, {}).then((data) => {
      this.dataSource = JSON.parse(JSON.stringify(data.data).replace(/id/g,'key').replace(/childList/g, 'children'));
    });
    fetchHandler(getUserMenuList, {}).then((data) => {
      this.treeSource = JSON.parse(JSON.stringify(data.data).replace(/id/g,'key').replace(/childList/g, 'children'));
    });
  }

  // 自定义事件， 用户自行定义对应业务逻辑

  openTransfer (res) {
    // 封装参数 (根据数据类型自行format)
    const targetArr = res.paramStr ? res.paramStr.split(',') : [];
    // 树状参数封装
    const targetTree = res.treeStr ? res.treeStr.split(',') : [];
    const param = {
      defaultSource: this.dataSource,
      defaultTarget: targetArr,
      treeSource: this.treeSource,
      treeTarget: targetTree,
      id: res.key
    };
    // 打开transferModal
    this.context.store.dispatch(initModals('transferModal', param, null));
  }

  dispathRole (res) {
    fetchHandler(getUserMenuList, {id: res.key}).then((result) => {
      if (result && result.code === 'success') {
        // 调用当前grid刷新
        RefreshGrid(this.context.store);
      }
    });
  }

  // 打开tab
  openTab (param, info) {
    this.props.addTab.bind(window.LayoutTab)(info, param);
  }

  render () {
// 用户只需要传入接口对象和配置的列信息即可
    return <ScGridTable config={this.state.tableConfig} />;
  }

}

// 最后我们得到自定义的gridTable,放置到业务page中。
export default TransferTable;

TransferTable.propTypes = {
  addTab: PropTypes.func,
  tableKey: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo/tables/transferTable.js